import { useState, useEffect } from 'react'

import css from './sass/createedit.module.scss'

import { isTitleDuplicated } from './auctionsadminutil'

export default function DuplicatedTitleWarning({ title, items, item }) {

  const [isDuplicated, setIsDuplicated] = useState(false)

  useEffect(() => {
    if (item) {
      let filteredItems = []
      if (item.ItemId) filteredItems = items.filter(ele => ele.ItemId !== item.ItemId)
      else if (item.FixedItemId) filteredItems = items.filter(ele => ele.FixedItemId !== item.FixedItemId)
      setIsDuplicated(isTitleDuplicated(title, filteredItems))
      return
    }
    setIsDuplicated(isTitleDuplicated(title, items))
  }, [title, items])


  if (!isDuplicated) return <></>

  return (
    <p className={css['duplicate-warning']}>
      There is already an item with this title in the auction. Please consider changing it to avoid confusion at the end of the auction.
    </p>
  )
}